import React, { Component, useState, useEffect, useRef } from "react";
import { fabric } from "fabric";

import Canvas from "./Canvas";

import { Filters } from "../filters";

// these are 'ad'
const SHARED_FILTERS = ["contrast", "exposure", "saturation"];
const BASE_FILTER = new fabric.Image.filters.BaseFilter();

const Editor = React.forwardRef((props, ref) => {
  let { filter, adjustments, image } = props.state;

  const [composition, setComposition] = useState({
    canvas: null,
    canvasImage: null,
  });

  const [enabled, setEnabled] = useState(true);
  const [isReady, setReady] = useState(false);

  const { canvas, canvasImage } = composition;

  // Memoized adjustments to avoid unnecessary re-renders
  const adjustmentNames = React.useMemo(
    () => Object.keys(adjustments),
    [adjustments]
  );
  const adjustmentValues = React.useMemo(
    () => adjustmentNames.map((key) => adjustments[key]),
    [adjustments, adjustmentNames]
  );

  const canvasImageExists = canvasImage != null;

  useEffect(() => {
    if (!canvasImage || !isReady) {
      return;
    }

    let filters = [];
    if (filter) {
      let fabricFilter = Filters[filter.type];
      fabricFilter.intensity = filter.data?.intensity || filter.intensity;
      filters.push(fabricFilter);
    }

    adjustmentNames.forEach((key) => {
      let filter = Filters[key];
      if (SHARED_FILTERS.indexOf(key) == -1) {
        filters.push(filter);
      }
    });

    if (enabled) {
      canvasImage.filters = filters;
    } else {
      canvasImage.filters = [BASE_FILTER];
    }

    canvasImage.applyFilters();
    canvas.renderAll();
  }, [canvasImageExists, filter?.type, enabled, isReady]);

  useEffect(() => {
    if (!canvasImage || !isReady) {
      return;
    }

    if (filter) {
      let fabricFilter = Filters[filter.type];
      fabricFilter.intensity = filter.data?.intensity || filter.intensity;
      if (filter.data) {
        Object.keys(filter.data).forEach((attribute) => {
          fabricFilter[attribute] = filter.data[attribute];
        });
      }
    }

    adjustmentNames.forEach((key) => {
      if (key == "hsl") {
        let fabricFilter = Filters[key];

        let hsl = adjustments[key];
        let saturation = hsl.saturation || 0;
        let luminance = hsl.luminance || 0;
        fabricFilter[key] = [
          hsl.hue,
          1 + saturation / 100.0,
          1 + luminance / 100.0,
        ];
      } else if (SHARED_FILTERS.indexOf(key) == -1) {
        let fabricFilter = Filters[key];
        fabricFilter[key] = adjustments[key];
      } else {
        let fabricFilter = Filters[filter.type];
        let scalar = key == "exposure" ? 5 : 100;
        let value = adjustments[key] * scalar;
        fabricFilter[key] += value;
        let newValue = fabricFilter[key];
        if (newValue > scalar) {
          fabricFilter[key] = scalar;
        } else if (newValue < -scalar) {
          fabricFilter[key] = -scalar;
        }
      }
    });

    canvasImage.applyFilters();
    canvas.renderAll();
  }, [adjustmentValues, canvasImageExists, filter, isReady]);

  return (
    <Canvas
      ref={ref}
      state={props.state}
      image={props.image}
      onLoaded={(canvas, canvasImage) =>
        setComposition({ canvas, canvasImage })
      }
      onLongPressStart={() => setEnabled(false)}
      onLongPressEnd={() => setEnabled(true)}
      onTextChange={(text) => props.onTextChange(text)}
      onImageSaved={(image) => props.onImageSaved(image)}
      onReady={(isReady) => setReady(isReady)}
    />
  );
});

export default Editor;
